import { Badge, Icon, cn } from '@kognitos/lattice';

import type {
  IRainAgentIdentity,
  TRainAgentTone,
} from '../utils/agent-identity';

export interface IRainAgentChipProps {
  identity: IRainAgentIdentity;
  className?: string;
}

const TONE_CLASSES: Record<TRainAgentTone, string> = {
  neutral: 'bg-muted text-foreground',
  brand: 'bg-alternate-7/20 text-alternate-7',
};

/**
 * Tinted badge naming an agent by its glyph and product name. Used by
 * transfer markers so every agent in a handoff reads the same way.
 */
export function RainAgentChip({ identity, className }: IRainAgentChipProps) {
  const { avatar, name, tone } = identity;
  return (
    <Badge
      variant="secondary"
      className={cn(
        'shrink-0 gap-1 whitespace-nowrap rounded-lg border-transparent px-1.5 py-0.5 text-sm font-medium',
        TONE_CLASSES[tone],
        className,
      )}
      data-testid="rain-agent-chip"
      data-agent-id={identity.agentId}
    >
      {avatar.kind === 'icon' && (
        <Icon type={avatar.icon} size="xs" aria-hidden />
      )}
      {name}
    </Badge>
  );
}
